import { id, list, listsRetrievalError } from "@planzone/dto";
import { Identifiable, ListsRetrievalFilter, Project } from "@planzone/dto";
import { areListsRetrievalFilters } from "../../utils/areListsRetrievalFilters";
import { State, SearchResult } from "./types";

function getProjectState(
  state: State,
  {
    project,
    filter,
  }: { project: Identifiable<Project>; filter: ListsRetrievalFilter },
): { result: SearchResult; index: number } {
  const index = state.findIndex(
    (res) =>
      res.project.uuid === project.uuid &&
      areListsRetrievalFilters(filter, res.filter),
  );

  return {
    index,
    result:
      index !== -1
        ? state[index]
        : {
            project,
            filter,
            lists: { ...list, uuid: id },
            request: {
              isPending: false,
              isSuccessful: false,
              isFailure: false,
            },
            callCount: 0,
            error: listsRetrievalError,
            canRetrieveNextProjects: true,
          },
  };
}

export { getProjectState };
